"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDateToOffsetUtc = void 0;
var get_intl_date_time_format_1 = require("./get-intl-date-time-format");
var get_value_for_date_property_1 = require("./get-value-for-date-property");
var pad_number_to_length_1 = require("./pad-number-to-length");
/**
 * Converts a Date to an equivalent UTC Date, offset by a given IANA time zone.
 * The UTC date functions (e.g. `date.getUTCHours()`) can then be used to get 'local' values for the time zone.
 *
 * For example, given the time zone `"Pacific/Auckland"` with an offset of `+12:00`:
 *
 * `"2019-09-09T05:00:00+12:00"` => `"2019-09-09T05:00:00.000Z"` => `getUTCHours()` = 5
 * `"2019-09-09T05:00:00-04:00"` => `"2019-09-09T21:00:00.000Z"` => `getUTCHours()` = 21
 * `"2019-09-09T05:00:00Z"`      => `"2019-09-09T17:00:00.000Z"` => `getUTCHours()` = 17
 *
 * @hidden
 * @param date The original Date value.
 * @param ianaTimeZoneName The IANA name of the time zone to offset the date by.
 * @returns A UTC Date that has been offset by the given time zone.
 */
var convertDateToOffsetUtc = function (date, ianaTimeZoneName) {
    var parts = get_intl_date_time_format_1.getIntlDateTimeFormat({
        hour12: false,
        timeZone: ianaTimeZoneName,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).formatToParts(date);
    var year = pad_number_to_length_1.padNumberToLength(Number(get_value_for_date_property_1.getValueForDateProperty(parts, 'year')), 4);
    var month = get_value_for_date_property_1.getValueForDateProperty(parts, 'month');
    var day = get_value_for_date_property_1.getValueForDateProperty(parts, 'day');
    /**
     * https://bugzilla.mozilla.org/show_bug.cgi?id=1284868
     * Firefox bug with '2-digit' format on hour in certain locales (e.g. Bulgarian) which causes it to only return one digit.
     * This results in an incorrect UTC string therefore we need to pad the hours to two digits.
     *
     * https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
     * Chromium 80+ now outputs midnight as 24 hours, whereas we need this to be 0.
     * This fix replicates setting hourCycle to 'h23' for DateTimeFormat, but hourCycle isn't working with unit tests.
     */
    var hour = pad_number_to_length_1.padNumberToLength(Number(get_value_for_date_property_1.getValueForDateProperty(parts, 'hour')) % 24, 2);
    var minute = pad_number_to_length_1.padNumberToLength(Number(get_value_for_date_property_1.getValueForDateProperty(parts, 'minute')), 2);
    var second = pad_number_to_length_1.padNumberToLength(Number(get_value_for_date_property_1.getValueForDateProperty(parts, 'second')), 2);
    var milliseconds = pad_number_to_length_1.padNumberToLength(date.getMilliseconds(), 3);
    var utcString = year + "-" + month + "-" + day + "T" + hour + ":" + minute + ":" + second + "." + milliseconds + "Z";
    return new Date(utcString);
};
exports.convertDateToOffsetUtc = convertDateToOffsetUtc;
//# sourceMappingURL=convert-date-to-offset-utc.js.map